import './LitPopup.scss';
import { LitElement } from 'lit';
import LitPopup from 'lit-popup';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export interface LitPopupElement {
    instance: LitPopup;
    _leaveTimeout: NodeJS.Timeout;
    _wasBodyLocked: boolean;
}

const NO_SCROLL_CLASS = 'no-scroll';

export class LitPopupElement extends LitElement {
    constructor() {
        super();
        this._wasBodyLocked = false;
    }

    createRenderRoot() {
        /**
         * Render template without shadow DOM. Note that shadow DOM features like
         * encapsulated CSS and slots are unavailable.
         */
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        const name = this.getAttribute('data-lit-popup');
        // const leaveDurationInSeconds = getCSSCustomProp(this, '--transition-leave-duration', 'number') as number;
        const leaveDurationInSeconds = 0.25;

        if (!name) {
            throw new Error('[lit-popup] Name should be provided.');
        }

        this.instance = new LitPopup(name, {
            onOpen: () => {
                clearTimeout(this._leaveTimeout);
                this._lockBodyScroll();
            },
            onOpenComplete: () => {
                const focusableOnOpenElement = this.renderRoot.querySelector<HTMLElement>('[data-focus-on-popup-open]');
                setTimeout(() => focusableOnOpenElement?.focus({ preventScroll: true }), 50);
            },
            onClose: () => {
                this._leaveTimeout = setTimeout(() => {
                    // проверяем, есть ли другие открытые попапы (меню и форма), чтоб не было двойного скрола
                    let isOtherPopupOpens = false;
                    const allPopups = document.querySelectorAll('app-lit-popup');
                    allPopups.forEach((popup) => {
                        if (popup.classList.contains('lit-popup--opened')) isOtherPopupOpens = true;
                    });

                    if (!isOtherPopupOpens) {
                        this._unlockBodyScroll();
                    }
                }, leaveDurationInSeconds * 1000);
            },
        });
    }

    attributeChangedCallback(name: string, oldVal: string | null, newVal: string | null) {
        super.attributeChangedCallback(name, oldVal, newVal);

        if (name === 'opened') {
            if (typeof newVal === 'string') {
                this.instance.open();
            } else {
                this.instance.close();
            }
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        clearTimeout(this._leaveTimeout);
        this._unlockBodyScroll();
        if (this.instance) {
            this.instance.destroy();
        }
    }

    open() {
        this.instance?.open();
    }

    close() {
        this.instance?.close();
    }

    protected _lockBodyScroll() {
        this._wasBodyLocked = document.body.classList.contains(NO_SCROLL_CLASS);

        if (!this._wasBodyLocked) {
            document.body.classList.add(NO_SCROLL_CLASS);

            if (this.instance.innerContainer) {
                disableBodyScroll(this.instance.innerContainer);
            }
        }
    }

    protected _unlockBodyScroll() {
        // if (!this._wasBodyLocked) {
        document.body.classList.remove(NO_SCROLL_CLASS);

        if (this.instance.innerContainer) {
            enableBodyScroll(this.instance.innerContainer);
        }
        // }
    }
}

customElements.define('app-lit-popup', LitPopupElement);

declare global {
    interface HTMLElementTagNameMap {
        'app-lit-popup': LitPopupElement;
    }
}
